import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { MarketplacePurchase} from "../../../models/dashboard/marketplacePurchase/marketplacePurchaseModel";

const getAllMarketplacePurchaseByMarketplace = (affiliateId:string): Promise<Array<MarketplacePurchase>> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplacePurchase/get-all-marketplace-purchases?affiliateId=${affiliateId}`)
}
export default getAllMarketplacePurchaseByMarketplace;